import { useQuery } from '@tanstack/react-query'
import { searchExperiences } from 'tripPlanner/api'
import * as ExperienceDetailKeys from 'tripPlanner/hooks/reactQueryKeys/experienceDetail'
import type { DrawerExperienceSearchTile } from './ExperienceDetailView'
import { mapImageIds } from './mapExperienceDetailToDrawer'

const EMPTY_EXPERIENCES: Array<DrawerExperienceSearchTile> = []
const EXPERIENCE_SEARCH_STALE_TIME = 5 * 60 * 1000

function mapSearchResultToDrawer(
  item: Awaited<ReturnType<typeof searchExperiences>>[number],
): DrawerExperienceSearchTile {
  const { images, redemptionLocations: _, ...rest } = item
  return { ...rest, images: mapImageIds(images) } as DrawerExperienceSearchTile
}

interface UseExperienceSearchOptions {
  searchQuery: string
  region?: string
  enabled: boolean
}

export default function useExperienceSearch({
  searchQuery,
  region,
  enabled,
}: UseExperienceSearchOptions) {
  const queryResult = useQuery({
    queryKey: ExperienceDetailKeys.search(searchQuery, region),
    queryFn: () => searchExperiences(searchQuery, region),
    enabled: enabled && !!searchQuery,
    select: (data) => data.map(mapSearchResultToDrawer),
    staleTime: EXPERIENCE_SEARCH_STALE_TIME,
  })

  return {
    experiences: queryResult.data ?? EMPTY_EXPERIENCES,
    isLoading: queryResult.isLoading && queryResult.fetchStatus !== 'idle',
    isError: queryResult.isError,
    refetch: queryResult.refetch,
  }
}
